import React from 'react'
import { FormattedNumber } from 'react-intl'
import { FlexRow, FlexColumn, Text, Card } from 'elements'
import SeverityCircle from '../../common/SeverityCircle'

type Props = {
  anomalyCountHigh: number
  anomalyCountMedium: number
  anomalyCountLow: number
}

export default function AnomaliesCard(props: Props) {
  const { anomalyCountHigh, anomalyCountMedium, anomalyCountLow } = props

  return (
    <Card width="365px" height="265px" flexDirection="column" pt="xlarge">
      <FlexRow justifyContent="center">
        <Text fontSize="xlarge" fontWeight="bold">
          Anomalies
        </Text>
      </FlexRow>
      <FlexRow height="100%" justifyContent="space-around" alignItems="center" py="xxlarge">
        <FlexColumn height="100%" justifyContent="space-evenly">
          <FlexRow alignItems="center">
            <SeverityCircle severity={2} styleProps={{ boxProps: { mr: 'small' } }} />
            <Text fontSize="xlarge" fontWeight="bold">
              High
            </Text>
          </FlexRow>
          <FlexRow alignItems="center">
            <SeverityCircle severity={1} styleProps={{ boxProps: { mr: 'small' } }} />
            <Text fontSize="xlarge" fontWeight="bold">
              Medium
            </Text>
          </FlexRow>
          <FlexRow alignItems="center">
            <SeverityCircle severity={0} styleProps={{ boxProps: { mr: 'small' } }} />
            <Text fontSize="xlarge" fontWeight="bold">
              Low
            </Text>
          </FlexRow>
        </FlexColumn>
        <FlexColumn height="100%" justifyContent="space-evenly">
          <Text fontSize="xlarge">
            <FormattedNumber value={anomalyCountHigh} />
          </Text>
          <Text fontSize="xlarge">
            <FormattedNumber value={anomalyCountMedium} />
          </Text>
          <Text fontSize="xlarge">
            <FormattedNumber value={anomalyCountLow} />
          </Text>
        </FlexColumn>
      </FlexRow>
    </Card>
  )
}
